/**
 * @namespace Salla.cookie
 */
export default class Cookie {
  constructor() {
    //@ts-ignore
    Salla.event.on("cookies::remove", (key) => this.remove(key));
    //@ts-ignore
    Salla.event.on("cookies::add", (key, value) => this.set(key, value));
  }
  keysToRemove: Array<string> = [
    "__said",
    "__ssid",
    "theme_edit",
    "ws_port",
    "s-token"
  ];
  dynamicKeysToRemove: Array<string> = ["affiliate", "cart"];

  get(key) {
    //@ts-ignore
    return document.cookie
      .split("; ")
      .find((row) => row.startsWith(key + "="))
      ?.split("=")[1];
  }

  set(key, value = "", days = 10) {
    let expires = "";
    if (days) {
      let date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }

    let sameSite = salla.helpers.isIframe() ? 'None' : 'Lax';

    document.cookie = `${key}=${value}${expires}; path=/; SameSite=${sameSite}; secure`;

    return this;
  }

  remove(key) {
    let sameSite = salla.helpers.isIframe() ? 'None' : 'Lax';
    document.cookie = `${key}=; Max-Age=0; path=/; SameSite=${sameSite}; secure`;
    return this;
  }

  clearAll(force = false) {
    return this.clean(force);
  }


  clean(force) {
    document.cookie.split(";")
      .map(cookie => cookie.split("=")[0].trim())
      .filter(cookieName => force || this.keysToRemove.includes(cookieName) || this.dynamicKeysToRemove.some(key => cookieName.startsWith(key)))
      .forEach(cookieName => this.remove(cookieName));
    return this;
  }

  getCookieByPrefix(prefix) {
    return document.cookie.split('; ')
      .map(cookie => cookie.split('=')[0])
      .filter(key => key.startsWith(prefix));
  }

  clearCookieByPrefix(prefix) {
    return this.getCookieByPrefix(prefix)
      .forEach(cookieName => this.remove(cookieName));
  }
}
